import { Component, EventEmitter, Inject, Injector, Input, Output, forwardRef } from '@angular/core';
import { ControlContainer, FormGroupDirective, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerDirective } from 'ngx-bootstrap/datepicker';
import { SmUiComponent } from 'common/components/ui-components/sm-ui/sm-ui.component';
import { noop } from 'rxjs';
import { DateTimeModel } from './date-time.model';
import { SystemService } from 'common/services/core-services/system.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'sm-datetimepicker',
  templateUrl: './sm-datetimepicker.component.html',
  styleUrls: ['./sm-datetimepicker.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SmDatetimepickerComponent),
      multi: true,
    },
    DatePipe,
    SystemService
  ],
})
export class SmDatetimepickerComponent extends SmUiComponent {
  bsValue = new Date();
  maxDate = new Date();
  minDate = new Date();
  @Output() date = new EventEmitter<any>();
  @Input() dateString: string;
  // ngControl: NgControl;
  onTouched: () => void = noop;
  onChange: (_: any) => void = noop;
  inputDatetimeFormat = 'DD/MM/YYYYY hh:mm';
  @Input() disabled = false;
  @Input() seconds = true;
  @Input() hourStep = 1;
  @Input() minuteStep = 15;
  @Input() secondStep = 30;
  meridian = true;
  firstTimeAssign = true;
  showTimePickerToggle = false;
  datetime: any = new DateTimeModel();
  currentDateTime: Date;
  bsConfig: Partial<BsDatepickerConfig>;

  constructor(
    private datepipe: DatePipe,
    @Inject(Injector) protected override injector: Injector,
    public ss: SystemService,
    
  ) {
    super(injector);
  }


  override ngOnInit(): void {
    super.ngOnInit();
    this.props.propminDate = this.props.propminDate ? new Date(this.props.propminDate) : new Date();
    this.props.propmaxDate = this.props.propmaxDate ? new Date(this.props.propmaxDate) : new Date();
    this.bsConfig = {
      isAnimated: true,
      dateInputFormat: this.props.propFormat,
      minMode: this.props.propFormat === 'YYYY' ? 'year' : 'day',
      adaptivePosition: true,
    };
    this.currentDateTime = new Date();
    //console.log(this.props.propisPlaceholder.isIconVisible)
  }

  preventOpen(event: Event): void {
    if (this.props.readOnly) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  onOpenCalendar(event) { }



  onValueChange(event: any) {
    const dateString = this.ss.convertToDateFormat(event);
    this.date.emit(dateString);
    this.showTimePickerToggle = true;
  }


  inputBlur($event: any) {
    this.onTouched();
  }

  onInputChange($event: any) {
    const value = $event.target.value;
    const dt = DateTimeModel.fromLocalString(value);
    if (dt) {
      this.datetime = dt;
      this.setDateStringModel();
    } else if (value.trim() === '') {
      this.datetime = new DateTimeModel();
      this.dateString = '';
      this.onChange(this.dateString);
    } else {
      this.onChange(value);
    }
  }


  setDateStringModel() {
    this.dateString = this.datetime.toString();
    if (!this.firstTimeAssign) {
      this.onChange(this.dateString);
    } else {
      if (this.dateString !== null) {
        this.firstTimeAssign = false;
      }
    }
  }



  onDateChange($event: any) {
    if ($event.year) {
      $event = `${$event.year}-${$event.month}-${$event.day}`;
    }
    const date = DateTimeModel.fromLocalString($event);
    if (!date) {
      this.dateString = this.dateString;
      return;
    }
    if (!this.datetime) {
      this.datetime = date;
    }
    this.datetime.year = date.year;
    this.datetime.month = date.month;
    this.datetime.day = date.day;
    this.setDateStringModel();
  }

  toggleDateTimeState($event: any) {
    this.showTimePickerToggle = !this.showTimePickerToggle;
    $event.stopPropagation();
    $event.preventDefault();
  }

  onTimeChange(event: any) {
    this.datetime.hour = event.hour;
    this.datetime.minute = event.minute;
    this.setDateStringModel();
  }
}
